module.exports = __webpack_public_path__ + "img/large-home-g0652fe4be_1280.8b85c023.jpg";